import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string | number;
}
interface DropdownOptionProps {
  name?: string,
  initialValue?: any;
  dataList?: Option[];
  onChangeSelect?: (params: Option) => void;
  placeholder?: string;
  disabled?: boolean,
  className?: string,
  classNamePrefix?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
  labelTop?: string,
  isClearable?: boolean,
  isMulti?: boolean
}

const DropdownOptionStar = ({
  name = '',
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = '',
  classNamePrefix = '',
  isHasOptionAll = false,
  optionAll,
  isClearable = false,
  isMulti = false
}: DropdownOptionProps) => {
  const { t, i18n } = useTranslation();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    const result: any = isHasOptionAll ? [optionAll].concat(dataList) : dataList;
    setOptions((_prev: any) => result);
  }, [dataList, i18n?.language]);

  return (
    <div className="position-relative">
      <Select
        options={options}
        value={(initialValue || isHasOptionAll) ? options.find((item: any) => item.value === initialValue) : null}
        name={name}
        isDisabled={disabled}
        onChange={(e: any) => onChangeSelect && onChangeSelect(e)}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        className={className}
        classNamePrefix={classNamePrefix}
        isClearable={isClearable}
        formatOptionLabel={(option: any) => {
          return option?.value ? (<div>{t(option?.label)} <i className="ri-star-fill align-bottom" style={{ color: "#ffbc0e" }}></i></div>) : <div>{t(option?.label)}</div>
        }}
        isMulti={isMulti}
      />
    </div>
  );
};

export default DropdownOptionStar;
